export default __webpack_public_path__ + "static/media/comfortaa-light-webfont.4255dda7.woff";